
import {defineComponent, reactive} from "vue";
import { getServicePhoneText, getServicePhoneTel } from '@/utils/common';

export default defineComponent({
  name: "DentistryService",
  setup() {
    const state = reactive({
      show: false,
      actions: [
        {name: getServicePhoneText(), tel: getServicePhoneTel()}
      ]
    })
    const toTel = (tel) => {
      state.show = false
      location.href = tel
    }
    return {
      toTel,
      state
    }
  }
})
